import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanDeactivateFn } from '@angular/router';

import { WizardComponent } from '../components/wizard/wizard.component';
import { FastLaneWizardService } from '../services/fastlane-wizard.service';

export const fastlaneWizardExitGuard: CanDeactivateFn<WizardComponent> = (
	_component: WizardComponent,
	_currentRoute: ActivatedRouteSnapshot,
	_currentState: RouterStateSnapshot,
	nextState: RouterStateSnapshot
) => {
	const fastlaneWizardService = inject(FastLaneWizardService);
	if (fastlaneWizardService.getState().isValid && nextState.url.includes('fastlane/wizard')) {
		return true;
	}
	return fastlaneWizardService.actionExitWizard();
};
